const MESES_LETRAS = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

export const PERIODOS = { ANO_ACTUAL: "ano_actual", ULTIMOS_12: "ultimos_12" };

/**
 * Las 12 claves "MM-YYYY" del período elegido, en orden cronológico (para la tira de calor,
 * izquierda = mes más viejo). "Año en curso": enero a diciembre del año calendario actual.
 * "Últimos 12 meses": el mes en curso y los 11 anteriores.
 * @param {string} periodo - uno de PERIODOS
 * @param {Date} [hoy]
 * @returns {string[]}
 */
export const getMesesDelPeriodo = (periodo, hoy = new Date()) => {
  if (periodo === PERIODOS.ANO_ACTUAL) {
    const ano = hoy.getFullYear();
    return Array.from({ length: 12 }, (_, i) => `${String(i + 1).padStart(2, "0")}-${ano}`);
  }
  return Array.from({ length: 12 }, (_, i) => {
    const d = new Date(hoy.getFullYear(), hoy.getMonth() - (11 - i), 1);
    return `${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  });
};

/** "01-2026" → "ENE 26" — usada en tooltips, donde el año ayuda (2026-09-23: la cabecera de la
 * columna YA NO lo lleva, el año vive en el selector de período — ver `etiquetaMesCorta`). */
export const etiquetaMes = (mesClave) => {
  const [mm, yyyy] = mesClave.split("-");
  return `${MESES_LETRAS[parseInt(mm, 10) - 1]} ${yyyy.slice(2)}`;
};

/** "01-2026" → "ENE" — encabezado de columna de la tira de calor (2026-09-23, sin año: el año ya
 * está en el selector de período, repetirlo 12 veces era redundante). */
export const etiquetaMesCorta = (mesClave) => MESES_LETRAS[parseInt(mesClave.split("-")[0], 10) - 1];
